import styled from 'styled-components';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Button from '@sdk/components/primitives/Button';
import View from '@sdk/components/primitives/View';
import Text12 from '@sdk/components/ui/typography/Text12';

export const Container = styled(View)`
  display: flex;
`;

type WrapperProps = {
  isActive: boolean;
};

export const Wrapper = styled(Button)<WrapperProps>`
  background-color: ${(props): string =>
    props.isActive ? props.theme.colors.hoverBrand : 'transparent'};
  border-radius: 4px;
  display: grid;
  flex: 1;
  grid-template:
    'icon name' 1fr
    'icon description' 1fr
    / 30px 1fr;
  grid-gap: 0 10px;
  padding: 5px 6px;
  overflow: hidden;
`;

export const IconContainer = styled(View)`
  grid-area: icon;
`;

const MentionText = styled(Text12)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Name = styled(MentionText)`
  grid-area: name;
`;
Name.defaultProps = {
  bold: true,
  themeColor: ThemeColorType.gray,
};

export const Description = styled(MentionText)`
  grid-area: description;
`;
Description.defaultProps = {
  semiBold: true,
  themeColor: ThemeColorType.iconGray,
};
